export default __webpack_public_path__ + "static/media/logo_v1.7beb8728.png";